import { useTranslation } from "react-i18next";

import { ConfirmationModal } from "@pentabd/ui";

interface ConfirmationModalType {
  isModalOpen: boolean;
  isActive?: boolean;
  action?: () => void;
  onClose: () => void;
}

export const ChangeStatusConfirmationModal = ({
  isModalOpen,
  isActive,
  action,
  onClose,
}: ConfirmationModalType) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t(
        `EMPLOYEE.ACCOUNT_STATUS_MODAL.${
          isActive ? "INACTIVE_ACCOUNT" : "ACTIVE_ACCOUNT"
        }.TITLE`,
      )}
      isOpen={isModalOpen}
      onClose={onClose}
      closeAble
      overlay
      confirmButton={{
        label: t(
          `EMPLOYEE.ACCOUNT_STATUS_MODAL.${
            isActive ? "INACTIVE_ACCOUNT" : "ACTIVE_ACCOUNT"
          }.BUTTON`,
        ),
        type: !isActive ? "success" : "danger",
        onClick: action,
      }}
    />
  );
};
